import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input } from 'reactstrap';
import { uniqueId } from 'lodash';
import Translate, { t } from '../common/Translate';
import useValue from '../../services/Form/useValue';

const RimSize = (props) => {
  const { elementIds, question, setDisableNav } = props;
  const { questionId, sectionId, formId } = elementIds;
  const defaultValue = question.default_value;

  const [height, setHeight] = useValue(formId, sectionId, questionId, question.type, 'value.height', defaultValue);
  const [width, setWidth] = useValue(formId, sectionId, questionId, question.type, 'value.width', defaultValue);
  const [diameter, setDiameter] = useValue(
    formId,
    sectionId,
    questionId,
    question.type,
    'value.diameter',
    defaultValue,
  );

  const testHasValue = (params) => {
    let res = true;
    Object.keys(params).forEach((index) => {
      const param = params[index];
      if (!param || param === null || param === '' || param === undefined) {
        res = false;
      }
    });
    return res;
  };

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (testHasValue([height, width, diameter])) setDisableNav(false);
      else setDisableNav(true);
    }
  });

  return (
    <div className="question-wheel-dimension" data-cy={questionId}>
      <Row>
        <Col>
          <label className="mb-2" htmlFor="width">
            <Translate code="rim_width" />
          </label>
        </Col>
        <Col>
          <label className="mb-2" htmlFor="height">
            <Translate code="rim_height" />
          </label>
        </Col>
        <Col>
          <label className="mb-2" htmlFor="diameter">
            <Translate code="rim_diameter" />
          </label>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col>
          <Input
            type="select"
            value={width || ''}
            name="select"
            id="width"
            data-cy="width"
            onChange={(e) => setWidth(e.target.value)}
          >
            {question.width.map((option, index) => (
              <option key={uniqueId(index)}>{t(option)}</option>
            ))}
          </Input>
        </Col>
        <Col>
          <Input
            type="select"
            value={height || ''}
            name="select"
            id="height"
            data-cy="height"
            onChange={(e) => setHeight(e.target.value)}
          >
            {question.height.map((option, index) => (
              <option key={uniqueId(index)}>{t(option)}</option>
            ))}
          </Input>
        </Col>
        <Col>
          <Input
            type="select"
            value={diameter || ''}
            name="select"
            id="diameter"
            data-cy="diameter"
            onChange={(e) => setDiameter(e.target.value)}
          >
            {question.diameter.map((option, index) => (
              <option key={uniqueId(index)}>{t(option)}</option>
            ))}
          </Input>
        </Col>
      </Row>
      <Row />
    </div>
  );
};

export default RimSize;

RimSize.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['text', 'string', 'date', 'number', 'integer', 'rim_size']).isRequired,
    default_value: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.array]).isRequired,
    height: PropTypes.oneOfType([PropTypes.array]).isRequired,
    diameter: PropTypes.oneOfType([PropTypes.array]).isRequired,
  }),
  elementIds: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
  }).isRequired,
  setDisableNav: PropTypes.func,
};

RimSize.defaultProps = {
  question: {
    default_value: null,
  },
  setDisableNav: undefined,
};
